// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-6p0T2";
var _4 = "left-239ZY";
var _5 = "center-3D9tH";
var _6 = "right-3eogQ";
var _7 = "button-2MCMz";
var _8 = "backButton-3tzqO";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "left", _5 as "center", _6 as "right", _7 as "button", _8 as "backButton" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "left": _4, "center": _5, "right": _6, "button": _7, "backButton": _8 }
